import CrudTable, { TextField, TextArea, CheckField, ImageField } from './CrudTable';

export default function AdminTestimonials() {
  return (
    <CrudTable
      table="testimonials"
      title="Testimonials"
      itemLabel="testimonial"
      defaults={{ name: '', role: '', avatar: '', quote: '', rating: 5, featured: true }}
      columns={[
        { key: 'name', label: 'Name', className: 'col-span-3' },
        { key: 'role', label: 'Role', className: 'col-span-3' },
        { key: 'rating', label: 'Rating', className: 'col-span-2' },
        { key: 'featured', label: 'Featured', className: 'col-span-2', format: v => v ? 'Yes' : 'No' },
      ]}
      render={(it, set) => (
        <>
          <TextField label="Name" value={it.name} onChange={v => set({ ...it, name: v })} required />
          <TextField label="Role" value={it.role} onChange={v => set({ ...it, role: v })} />
          <ImageField label="Avatar" folder="testimonials" value={it.avatar} onChange={v => set({ ...it, avatar: v })} />
          <TextArea label="Quote" value={it.quote} onChange={v => set({ ...it, quote: v })} required />
          <TextField label="Rating (1-5)" type="number" value={it.rating} onChange={v => set({ ...it, rating: v })} />
          <CheckField label="Featured" value={it.featured} onChange={v => set({ ...it, featured: v })} />
        </>
      )}
    />
  );
}
